/* istanbul ignore file */
import { css } from 'styled-components';

export const commonButtonStyles = css`
  font-size: 14px;
  font-weight: 600;
  padding: 8px 11px;
`;
